// Single source of truth for "is this staffer an admin" — used by Task Engine (mutation/visibility gating) and the
// Reports productivity report (admin-only). Admin = the DB role is 'Admin', OR one of the named partners (role data
// isn't fully populated on ntrg_staff yet, so the names are a stopgap until it is). Keep the rule here, not inline,
// so it can't drift between call sites.
export function isAdminStaff(staffUser) {
  return staffUser?.role === 'Admin' || ['Philip Vivier', 'Josh Sanchez', 'Debbie Garcia'].includes(staffUser?.name);
}
